import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a9a00f6f-513d-431b-96c7-434b9e821f5d";
export const REGISTER_URL = "https://a.ntrk2.com/92d635ba-0265-4502-a988-0a783176f42e";

export const LOGIN_URL_MAP = {
  "beer78play.com": "https://a.ntrk2.com/b8fe707b-7349-4d24-8c93-13d87d0858ab",
  "be78er.com": "https://a.ntrk2.com/b8fe707b-7349-4d24-8c93-13d87d0858ab",
};

export const REGISTER_URL_MAP = {
  "beer78play.com": "https://a.ntrk2.com/36942132-a040-4dd8-8401-0cb2e7119e9b",
  "be78er.com": "https://a.ntrk2.com/36942132-a040-4dd8-8401-0cb2e7119e9b",
};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://beer78.kzw2a.com/download?openExternalBrowser=1&id=dfelf8l0z3urbrb";

export * from "./codes";
export * from "./context";
